import { signify } from "react-signify";

export const sCode = signify("");
export const sEmail = signify("");
